import { PdsWidget } from './pds-widget';
import { pdsI18n } from './pds-i18n';

export class PdsLogout extends PdsWidget {
  is = 'pds-logout';

  //Input
  authenticationType: 'google' | 'microsoft';

  selectedValue: string;
  logoutTimer: number;
  signOutOptions: {text: string, value: string}[];

  properties = {
    authenticationType: {
      type: String,
      value: 'google'
    }
  };

  ready(): void {
    super.ready();
    this.logoutTimer = window.setTimeout(() => {
                          this.signOut();
                        }, 30000);
  }

  getSignOutOptions(authenticationType): Array<{text: string, value: string}> {
    this.signOutOptions = [{ text: pdsI18n.getText('pds|logout|Sign out of Unified Classroom only'), value: 'sign-out-uc' },
                            { text: pdsI18n.getText('pds|logout|Sign out of all xx Authenticated applications',
                              { authenticationType: authenticationType.charAt(0).toUpperCase() + authenticationType.slice(1) }),
                                value: `sign-out-${authenticationType.toLowerCase()}` }];
    this.selectedValue = `sign-out-${authenticationType.toLowerCase()}`;
    return this.signOutOptions;
  }

  staySignedIn(): void {
    window.clearTimeout(this.logoutTimer);
    this.fire('pdsLogout', { 'type': 'STAY_SIGNED_IN', 'value': true });
  }

  signOut(): void {
    window.clearTimeout(this.logoutTimer);
    this.fire('pdsLogout', { 'type': 'SIGN_OUT', 'value': this.selectedValue });
  }
}
